"use client";

import { memo } from "react";
import {
  useA2UIComponent,
  type A2UIComponentProps,
  type Types,
} from "@a2ui/react";
import { renderChildren } from "./utils";

export const BeeOSCard = memo(function BeeOSCard({
  node,
  surfaceId,
}: A2UIComponentProps<Types.CardNode>) {
  useA2UIComponent(node, surfaceId);
  const props = node.properties;
  const rawChildren = props.children ?? (props.child ? [props.child] : []);
  const children = Array.isArray(rawChildren) ? rawChildren : [];

  const hostStyle: React.CSSProperties =
    node.weight !== undefined
      ? ({ "--weight": node.weight } as React.CSSProperties)
      : {};

  return (
    <div className="a2ui-card" style={hostStyle}>
      <section className="rounded-xl bg-card/80 backdrop-blur-sm text-card-foreground shadow-[0_0_0_1px_rgba(0,0,0,0.04),0_1px_3px_-1px_rgba(0,0,0,0.05)] dark:shadow-[0_0_0_1px_rgba(255,255,255,0.04),0_1px_3px_-1px_rgba(0,0,0,0.2)] p-4">
        {renderChildren(children, surfaceId)}
      </section>
    </div>
  );
});
